module.exports = __webpack_public_path__ + "img/FR41259.d371c32b.png";